import { denormalize, normalize } from 'normalizr'
import { useSelector } from 'react-redux'
import get from 'lodash/get'
import api from '../../api'
import { officeLocationsSchema } from '../normalizr'
import { useAsyncAction } from '../utils'
import createSlice from '../create-slice'
import { getEntities } from './entities'

const officeLocationsInitialState = {
  practices: {},
}

const officeLocationsSlice = createSlice({
  name: 'officeLocations',
  initialState: officeLocationsInitialState,
  reducers: {
    setOfficeLocations: (state, { payload: { practiceId, result } }) => {
      state.practices[practiceId] = state.practices[practiceId] || {}
      state.practices[practiceId].ids = result
    },
  },
})

const { actions } = officeLocationsSlice

const selectState = state => state[officeLocationsSlice.name]

export function useOfficeLocations(practiceId) {
  const { practices } = useSelector(selectState)
  const entities = useSelector(getEntities)
  return denormalize(
    get(practices, [practiceId, 'ids'], []),
    [officeLocationsSchema],
    entities,
  )
}

export function fetchOfficeLocations(practiceId) {
  return async dispatch => {
    const res = await api.practices.getPracticeOfficeLocations(practiceId)
    dispatch(
      actions.setOfficeLocations({
        practiceId,
        ...normalize(res, [officeLocationsSchema]),
      }),
    )
  }
}

export function useFetchOfficeLocations(practiceId) {
  return useAsyncAction(fetchOfficeLocations, practiceId)
}

export default officeLocationsSlice
